import request from '@/utils/request';

// 商店信息
export function getMarketBaseInfoApi(params) {
  return request({
    url: '/app-server/marketui/' + params.marketId + '/detail',
    method: 'GET',
    params: params
  });
}

// 应用列表
export function getAppListApi(params) {
  return request({
    url: '/app-server/marketui/' + params.marketId + '/indexApps',
    method: 'GET',
    params: params
  });
}

// 获取分类列表
export function getCategoryListApi(params) {
  return request({
    url: '/app-server/marketui/' + params.marketId + '/classifications',
    method: 'GET',
    params: params
  });
}

// 标签列表
export function getTagsListApi(params) {
  return request({
    url: '/app-server/marketui/' + params.marketId + '/tags',
    method: 'GET',
    params: params
  });
}

// 应用详情
export function getAppDetailApi(params) {
  return request({
    url: `/app-server/marketui/${params.marketId}/apps/${params.appId}/detail`,
    method: 'GET',
    params: {
      eid: params.eid
    }
  });
}

// 应用详情
export function getAppPackageArchApi(params) {
  return request({
    url: `/app-server/marketui/${params.marketId}/apps/${params.appId}/package/arch`,
    method: 'GET',
    params: {
      eid: params.eid,
      arch: params.arch
    }
  });
}

// 升级版本
export function getAppUpVersion(params) {
  return request({
    url: `/delivery-server/markets/${params.marketID}/deliveryapps/${params.appID}/upgradeableversions`,
    method: 'GET'
  });
}

// 升级版本
export function getBuyersAppUpVersion(params) {
  return request({
    url: `/delivery-server/customers/deliveryapps/${params.appID}/upgradeableversions`,
    method: 'GET'
  });
}

// 升级版本
export function getUpgradePackage(params) {
  return request({
    url: `/delivery-server/markets/${params.marketID}/deliveryapps/${params.appID}/upgradeablecombos`,
    method: 'GET'
  });
}

// 热门应用
export function getHotAppListApi(params) {
  return request({
    url: '/app-server/marketui/' + params.marketId + '/hotApps',
    method: 'GET',
    params: params
  });
}

export function getDownloadListApi(params) {
  return request({
    url:
      '/app-server/markets/' +
      params.marketId +
      '/apps/' +
      params.appID +
      '/versions/' +
      params.versions +
      '/offlinepackages',
    method: 'GET'
  });
}

export function openMarket(params) {
  return request({
    url: '/app-server/pendingmarkets',
    method: 'POST',
    data: params
  });
}

export function getOpenMarketRecoder(params) {
  return request({
    url: '/app-server/pendingmarket',
    method: 'GET',
    data: params
  });
}

export function updateOpenMarket(params) {
  return request({
    url: '/app-server/pendingmarket',
    method: 'PUT',
    data: params
  });
}

export function getMarketInfo(params) {
  return request({
    url: `/app-server/markets/${params.marketID}`,
    method: 'GET'
  });
}

export function putMarketInfo(params) {
  return request({
    url: `/app-server/markets/${params.marketID}`,
    method: 'PUT',
    data: params
  });
}

export function getMarketRegistryInfo(params) {
  return request({
    url: `/app-server/markets/${params.marketID}/registry`,
    method: 'GET'
  });
}

export function putMarketRegistryInfo(params) {
  return request({
    url: `/app-server/markets/${params.marketID}/registry`,
    method: 'PUT',
    data: params
  });
}

export function getStoreBannerList(data = {}) {
  return request({
    url: `/app-server/markets/${data.marketID}/banners`,
    method: 'GET'
  });
}

export function postStoreBanner(data = {}) {
  return request({
    url: `/app-server/markets/${data.marketID}/banners`,
    method: 'POST',
    data: {
      description: data.description,
      enable: data.enable,
      imageURL: data.imageURL,
      title: data.title
    }
  });
}

export function updateStoreBanner(data = {}) {
  return request({
    url: `/app-server/markets/${data.marketID}/banners/${data.bannerID}`,
    method: 'PUT',
    data: {
      description: data.description,
      enable: data.enable,
      imageURL: data.imageURL,
      title: data.title
    }
  });
}

export function deleteStoreBanner(data = {}) {
  return request({
    url: `/app-server/markets/${data.marketID}/banners/${data.bannerID}`,
    method: 'DELETE'
  });
}

export function getStoreAvailableTags(data = {}) {
  return request({
    url: `/app-server/markets/${data.marketID}/tags`,
    method: 'GET'
  });
}

// 获取相关应用
export function getRelatedApp(params = {}) {
  return request({
    url: `/app-server/markets/${params.marketID}/apps/${params.appID}/related`,
    params: {
      apptype: params.apptype,
      templateType: params.templateType
    },
    method: 'GET'
  });
}
// 获取历史版本信息
export function getHistoryVersionInfo(params = {}) {
  return request({
    url: `/app-server/markets/${params.marketID}/apps/${params.appID}/history/version`,
    method: 'GET',
    params: {
      templateType: params.templateType
    }
  });
}

// helm应用列表
export function getHelmAppListApi(params) {
  return request({
    url: '/app-server/marketui/' + params.marketId + '/landing',
    method: 'GET',
    params: params
  });
}

// 获取对应版本的套餐
export function getAppVersionPackage(params) {
  return request({
    url: `/app-server/marketui/${params.marketID}/apps/${params.appID}/version/${params.version}/packages`,
    method: 'GET',
    params: {
      templateType: params.templateType
    }
  });
}

// 下载file类型软件包
export function downloadFilePackage(params) {
  return request({
    url: `/app-server/markets/${params.marketID}/apps/${params.appID}/exec/${params.version}/downloads`,
    method: 'GET'
  });
}



// WEBPACK FOOTER //
// ./src/api/appStore.js